import { render } from "./MesajeClient.vue?vue&type=template&id=5005c198&scoped=true"
import script from "./MesajeClient.vue?vue&type=script&lang=js"
export * from "./MesajeClient.vue?vue&type=script&lang=js"

import "./MesajeClient.vue?vue&type=style&index=0&id=5005c198&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5005c198"]])

export default __exports__